/*
 * P1.5 : le tableau de caracteristiques suit la variante choisie.
 *
 * `specs.hauteur_cm`, `specs.largeur_cm` et `specs.couleur` vivent au niveau VARIANTE :
 * un meme article existe en 40 et en 170 cm. Le tableau doit donc changer quand
 * l'acheteur change de taille.
 *
 * Pourquoi ecouter le formulaire plutot que Dawn : a chaque changement de variante,
 * Dawn re-rend quelques identifiants precis (prix, stock, SKU) et pas un bloc
 * quelconque. S'accrocher a ses internes casserait a la premiere mise a jour du theme.
 * On lit donc simplement l'identifiant de variante dans le formulaire, ce qui est du
 * contrat public de Shopify et ne bouge pas.
 */
(function () {
  function init(racine) {
    var bloc = racine.querySelector('[data-pk-specs]');
    var source = racine.querySelector('[data-pk-specs-variantes]');
    if (!bloc || !source) return;

    var table;
    try {
      table = JSON.parse(source.textContent);
    } catch (e) {
      return; // donnees illisibles : on laisse le rendu serveur en place, jamais d'affichage casse
    }

    var champDimensions = bloc.querySelector('[data-pk-specs-dimensions]');
    var champCouleur = bloc.querySelector('[data-pk-specs-couleur]');

    function nombreLisible(n) {
      return String(Math.round(n * 10) / 10).replace(/\.0$/, '');
    }

    function appliquer(id) {
      var v = table[String(id)];
      if (!v) return;

      if (champDimensions) {
        var morceaux = [];
        if (v.h) morceaux.push('<strong>' + nombreLisible(v.h) + ' cm</strong> de hauteur');
        if (v.l) morceaux.push(nombreLisible(v.l) + ' cm de largeur');
        // Une variante sans dimension connue : on masque la ligne au lieu d'afficher un vide
        var ligne = champDimensions.closest('.pk-specs__ligne');
        if (morceaux.length) {
          champDimensions.innerHTML = morceaux.join(' · ');
          if (ligne) ligne.hidden = false;
        } else if (ligne) {
          ligne.hidden = true;
        }
      }

      if (champCouleur) {
        var ligneC = champCouleur.closest('.pk-specs__ligne');
        if (v.c) {
          champCouleur.textContent = v.c;
          if (ligneC) ligneC.hidden = false;
        } else if (ligneC) {
          ligneC.hidden = true;
        }
      }
    }

    // L'identifiant de variante vit dans l'input cache du formulaire produit
    var form = racine.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var input = form.querySelector('input[name="id"]');
    if (!input) return;

    var dernier = input.value;
    function verifier() {
      if (input.value === dernier) return;
      dernier = input.value;
      appliquer(input.value);
    }

    form.addEventListener('change', function () {
      // Dawn met l'input a jour APRES l'evenement de changement : on laisse passer un tour
      window.setTimeout(verifier, 0);
    });
    new MutationObserver(verifier).observe(input, { attributes: true, attributeFilter: ['value'] });
  }

  function demarrer() {
    document.querySelectorAll('.product, .product-form__wrapper, main').forEach(function (r) {
      if (r.querySelector('[data-pk-specs]')) init(r);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
